import { render, staticRenderFns } from "./progress-rating.vue?vue&type=template&id=12f26cd0"
import script from "./progress-rating.vue?vue&type=script&lang=ts"
export * from "./progress-rating.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports